import { shellEstimatesAPI } from "@/views/ShellEstimates/api";

export const getRoomPurposeOptions = async () => {
  try {
    const res = await shellEstimatesAPI.getRoomPurposeOptions();
    return res?.data;
  } catch (e) {}
};
export const getShellEstimates = async (params) => {
  try {
    const res = await shellEstimatesAPI.getShellEstimates(params);
    return res?.data;
  } catch (e) {}
};

export const shellEstimatesColumns = [
  {
    name: "entrance",
    label: "Подъезд",
    field: "entrance",
    align: "center",
    sortable: true,
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "floor",
    label: "Этаж",
    field: "floor",
    align: "center",
    sortable: true,
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "room_purpose_name",
    label: "Тип помещения",
    field: "room_purpose_name",
    align: "left",
    sortable: true,
  },
  {
    name: "purpose_type",
    label: "Кв/МОП",
    field: "purpose_type",
    align: "center",
    sortable: true,
  },
  {
    name: "room_name",
    label: "Комната",
    field: "room_name",
    align: "left",
    sortable: true,
  },
  {
    name: "floor_param_type_name",
    label: "Конструктив",
    field: "floor_param_type_name",
    align: "left",
    sortable: true,
  },
  {
    name: "volume",
    label: "Объем",
    field: "volume",
    align: "left",
    sortable: true,
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
];
